import { getIsServingFromEventScorecard, isEventLive } from '@draftkings/sportsbook-common-utils';
import type * as ContractTypes from '@draftkings/dk-data-layer';
import { getTeamLogo } from './getTeamLogo';
import { Team, LogosMap } from '../../contracts';

type GetTeamsInfoOptions = {
    mainScorecard: ContractTypes.MainScorecard | undefined;
    participants: ContractTypes.Participant[];
    logosMap: LogosMap | undefined;
    staticS3Host: string;
    swooshBaseUrl: string;
    isSwooshTeamLogosEnabledForSportSlider: boolean;
    isTeamSwap?: boolean;
    sportId?: string;
    eventStatus: string;
};

const TEAM_SCORE_MAPPER: { [key: number]: 'firstTeamScore' | 'secondTeamScore' } = {
    1: 'firstTeamScore',
    2: 'secondTeamScore'
};

export const getTeamsInfo = ({
    mainScorecard,
    participants,
    logosMap,
    staticS3Host,
    swooshBaseUrl,
    isSwooshTeamLogosEnabledForSportSlider,
    sportId,
    isTeamSwap,
    eventStatus
}: GetTeamsInfoOptions): { teams: Team[]; scores: string[] } => {
    const logosTeam = logosMap?.Teams;
    const onServe = Number(mainScorecard?.liveScoreData?.onServe);
    // TODO: kept for Legacy Widget Slider - to be removed with Legacy Home Page/Widget Slider deprecation
    const scores: string[] = [];

    // Filter and sort participants first
    const teamParticipants = participants
        .filter((p) => p.type === 'Team')
        .sort((a, b) => {
            if (a.sortOrder && b.sortOrder) {
                return a.sortOrder - b.sortOrder;
            }
            return 0;
        });

    // Check if all participants have defined logo URLs
    const teamLogos = teamParticipants
        .map((participant) =>
            getTeamLogo(participant, logosTeam, staticS3Host, swooshBaseUrl, isSwooshTeamLogosEnabledForSportSlider)
        )
        .filter((logo) => logo !== '');

    const shouldShowLogos = teamLogos.length === teamParticipants.length;

    const teams = teamParticipants.map((participant, index) => {
        const participantId = index + 1;
        const score = mainScorecard ? mainScorecard[TEAM_SCORE_MAPPER[participantId]] : '';
        scores.push(score);

        const logoUrl = shouldShowLogos ? teamLogos[index] : undefined;

        return {
            name: participant.name,
            logoUrl,
            score,
            isServing:
                isEventLive(eventStatus) &&
                getIsServingFromEventScorecard(onServe, participant.venueRole, sportId, isTeamSwap)
        };
    });

    return { teams, scores };
};
